import { CloudUpload } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { CardActionArea, CardContent } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../actions/alert";
import {
  getTermsAndConditionsDownload,
  postUploadDocument,
} from "../../../api/termsConditions";
import { handleAxiosError } from "../../../config/action-config";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../../actions/auth";

export default function DownloadUploadAgreement() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [itemDialog, setItemDialog] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (user.agreement_status === "verified") {
      navigate("/leads");
    }
    return;
  }, [user.agreement_status]);
  const getDocDownloadData = () => {
    const token = user.token;

    getTermsAndConditionsDownload(token)
      .then((blob) => {
        // const file = window.URL.createObjectURL(blob.data);
        // console.log("filedatat====", file);
        // console.log("blob====", blob.data);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", "termscondition.pdf");
        document.body.appendChild(link);
        link.click();

        // window.open(file, "_blank");
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  return (
    <>
      {user.agreement_status === "signed" ? (
        <Typography>
          Thank you for uploading the Signed Agreement. Please wait while it is
          getting verified.
        </Typography>
      ) : (
        <div style={{ margin: "20px" }}>
          <Box component="main" sx={{ flexGrow: 1, p: 3, pt: 6 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} md={4}>
                <Card sx={{ mb: 2 }}>
                  <CardHeader
                    title="Download Agreement"
                    className="card-header"
                  />
                  <CardContent>
                    <center>
                      <Button
                        onClick={() => {
                          getDocDownloadData();
                        }}
                        className="blue-button"
                      >
                        Download
                      </Button>
                    </center>
                  </CardContent>
                </Card>
                <Card>
                  <CardHeader
                    title="Upload Signed Document"
                    className="card-header"
                  />
                  <CardContent>
                    <center>
                      <Button
                        onClick={() => {
                          setItemDialog(true);
                        }}
                        className="blue-button"
                      >
                        Upload Document
                      </Button>
                    </center>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={8} md={8}>
                <Card>
                  <CardHeader title="Note" className="card-header" />
                  <CardContent>
                    <ul>
                      <li>
                        Please download the agreement document given in the left
                        and fill in the details and sign it.
                      </li>
                      <br />
                      <li>
                        Upload the Signed Document through the 'Upload' button
                        in left. For any queries contact{" "}
                        <a className="blue" href="mailto:partner@vastedge.com">
                          partner@vastedge.com
                        </a>
                        .
                      </li>
                      <br />
                    </ul>
                    <Typography variant="p" color="red">
                      Once you send the signed document Vast Edge Team will
                      verify your details and notify you soon.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
          <ItemDialogDocumentUploadTab
            open={itemDialog}
            setOpen={setItemDialog}
          />
        </div>
      )}
    </>
  );
}

function ItemDialogDocumentUploadTab({ open, setOpen }) {
  const user = useSelector((state) => state.user);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  const onUploadDocument = async (formData) => {
    try {
      const { data } = await postUploadDocument(
        formData,
        user.roleId,
        user.token
      );
      // window.location.reload();
      dispatch(getUser(user.token));
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  const submit = () => {
    const formData = new FormData();
    if (selectedFile == "") {
      setOpen("ATTACHMENTS_TAB");
      return dispatch(showAlert("Attachment can't be empty"));
    }
    if (/\.(pdf)$/.test(selectedFile.name)) {
      formData.append("myFile", selectedFile);
      setLoader(true);
      onUploadDocument(formData).then(() => {
        // console.log("uploaded");
        setLoader(false);
        setIsSelected(false);
        setSelectedFile("");
        setOpen(false);
      });
    } else {
      setIsSelected(false);
      setSelectedFile("");
      setOpen(false);
      return dispatch(showAlert("Please upload pdf file."));
    }
  };
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);

    // Check if lastModifiedDate is available in the File object
    if ("lastModifiedDate" in event.target.files[0]) {
      console.log("Using lastModifiedDate");
      // Use the lastModifiedDate for older browsers
      console.log("lastModifiedDate:", event.target.files[0].lastModifiedDate);
    } else {
      console.log("Using lastModified");
      // Use the lastModified for modern browsers
      console.log("lastModified:", event.target.files[0].lastModified);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Upload Document
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} md={12}>
            <Card sx={{ boxShadow: "none !important" }}>
              <div class="upload-files-container">
                <div class="drag-file-area">
                  <div class="upload-icon">
                    <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                  </div>
                  <h6 class="dynamic-message"> Drag & drop any file here </h6>
                  <div class="browse-files">
                    <input
                      className="file-upload"
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                    {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          lastModified:
                          {selectedFile.lastModifiedDate
                            ? selectedFile.lastModifiedDate.toLocaleDateString()
                            : new Date(
                                selectedFile.lastModified
                              ).toLocaleDateString()}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Cancel
        </Button>

        <Button disabled={loader} className="blue-button" onClick={submit}>
          {"Submit"}
        </Button>

        {loader && (
          <Box sx={{ ml: 1 }}>
            <CircularProgress />
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
}
